export default "__VITE_ASSET__C86hc5$Z__"